import { render, staticRenderFns } from "./ConquestNotif.vue?vue&type=template&id=2572dff2&"
import script from "./ConquestNotif.vue?vue&type=script&lang=js&"
export * from "./ConquestNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports